import sanitizeCartItem from "./sanitizeCartItem"

export default function (cartItems) {
  for (const cartItem in cartItems) {
    cartItems[cartItem] = sanitizeCartItem(cartItems[cartItem])
  }
  return cartItems
}
